import { useEffect, useState } from "react";
import styles from "./style.module.scss";
import { Container, Row } from "reactstrap";
import DashboardLink from "@components/content/DashboardLink";

import SuscriptionIcon from '@assets/icons-png/bg-calendario.png';
import TarifarioIcon from '@assets/icons-png/bg-tarifario.png';
import ClientIcon from '@assets/icons-png/bg-clientes.png';
import CotizacionIcon from '@assets/icons-png/bg-cotizacion.png';
import FacturacionIcon from '@assets/icons-png/bg-facturacion.png';
import ProvedorIcon from '@assets/icons-png/bg-provedor.png';
import ContabilidadIcon from '@assets/icons-png/bg-contabilidad.png';
import DashboardCard from "@components/content/DashboardCard";
import { useAppSelector } from "@/store/hooks";
import { isAdmin } from "@utils/Auth";

const UserDashboard = () => {
  const compraUsd = useAppSelector(state => state.currency.compraUsd || 0)
  const ventaUsd = useAppSelector(state => state.currency.ventaUsd || 0)
  const [isAdminUser, setAdminUser] = useState<boolean>(false)

  useEffect(() => {
    confirmAdmin()
  }, []);

  const confirmAdmin = async () => {
    const isAdmins = await isAdmin()
    setAdminUser(isAdmins)
  }

  const renderAdminSection = () => {
    if (isAdminUser) {
      return (
        <Row className={styles.dashboardItems}>
          <DashboardLink
            to="/admin/suscriptions"
            icon={SuscriptionIcon}
            iconAlt="Icono suscripciones"
            xl={{ size: 1, offset: 3 }}
          >
            Suscripciones
          </DashboardLink>
        </Row>
      )
    }
  }

  return (
    <Container fluid>
      <Row className={styles.dashboardItems}>
        <DashboardLink
          to="/user/products"
          icon={TarifarioIcon}
          iconAlt="Icono productos"
          xl={{ size: 1, offset: 3 }}
        >
          Inventario
        </DashboardLink>
        <DashboardLink
          to="/user/clients"
          icon={ClientIcon}
          iconAlt="Icono Clientes"
        >
          Clients
        </DashboardLink>
        <DashboardLink
          to="/user/quotes"
          icon={CotizacionIcon}
          iconAlt="Icono Cotizaciones"
        >
          Cotizar
        </DashboardLink>
        <DashboardLink
          to="/user/invoices"
          icon={FacturacionIcon}
          iconAlt="Icono Facturacion"
        >
          Facturar
        </DashboardLink>
        <DashboardLink
          to="/user/providers"
          icon={ProvedorIcon}
          iconAlt="Icono Provedor"
        >
          Proveedores
        </DashboardLink>
        <DashboardLink
          to="/user/dashboard-accounting"
          icon={ContabilidadIcon}
          iconAlt="Icono Contabilidad"
        >
          Contabilidad
        </DashboardLink>

      </Row>
      {renderAdminSection()}

      <Row>
        <DashboardCard
          cardType="noticias"
          cardTitle="Noticias"
        >
          <p>
            No hay noticias
          </p>
        </DashboardCard>
        <DashboardCard
          cardType="deudores"
          amounts={[{ amount: "3,500.00", amountTitle: "Client Contado" }]}
          cardTitle="Deudores"
        />
        <DashboardCard
          cardType="acredores"
          amounts={[{ amount: "3,500.00", amountTitle: "Client Contado" }]}
          cardTitle="Acredores"
        />
        <DashboardCard
          cardType="cuentas"
          cardTitle="Moneda"
        >
          <h4> Tipo de Cambio $</h4>
          <p>
            Compra: <b>¢{compraUsd} </b> Venta: <b>¢{ventaUsd} </b>
          </p>
        </DashboardCard>
      </Row>
    </Container>
  );
}

export default UserDashboard;
